import { createContext } from "react";

export const UIContext = createContext({
  alert: {},
  showAlert: () => {},
  dialog: {},
  showDialog: () => {},
});
